<template>
    <div class="viewer-document-box">
        <DocumentCard
            v-bind="documentCardProps"
            ref="documentCardRef"
        />
    </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref, computed } from 'vue';
import { modalDefinedEmits, type ToolbarReference, useModalBuilder } from '@helpers/modal-building-helper';
import { messageBoxResult } from '@components/dialogs/message-box';
import { DxButton } from 'devextreme-vue/button';
import DocumentCard from "@components/document-card/DocumentCard.vue";
import type { IDocumentCardProps, IDocumentInitialState } from "@components/document-card/models/IDocumentCardProps";
import type { IViewerDocumentBoxProps } from "@/.shared/components/dialogs/models/IViewerDocumentBoxProps";
import { dangerButtonProps, primaryButtonProps } from '@/.shared/helpers/button-helper';
import { useIntl } from '@/.shared/services/i18n/i18nservice';
const documentCardRef = ref<InstanceType<typeof DocumentCard>>();

const props = withDefaults(defineProps<IViewerDocumentBoxProps>(), {
  title: '',
  documentList: () => [],
  align: 'horizontal',
});

const documentCardProps = computed<IDocumentCardProps>(() => {
  return {
    title: props.title,
    actions: ['open', 'download'],
    align: props.align,
    initialDocumentList: props.documentList
  };
});

onMounted(() => {
    const modal = useModalBuilder();
    modal.setContext(getCurrentInstance()!);

    configureButtons(modal);
});

const intl = useIntl();

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
    let validarButton: ToolbarReference<DxButton>;
    let rechazarButton: ToolbarReference<DxButton>;
    let cancelarButton: ToolbarReference<DxButton>;

    rechazarButton = modal.addButton('rechazar', dangerButtonProps(intl.i18n.t("borradores-operacion.grid.rechazar_autorizacion_cliente")), { toolbar: 'bottom', location: 'before' });
    rechazarButton.update(w => w.onClick = async () => {
        modal.close({ result: messageBoxResult.no });
    });

    validarButton = modal.addButton('validar', primaryButtonProps(intl.i18n.t("borradores-operacion.grid.validar_autorizacion_cliente")), { toolbar: 'bottom', location: 'after' });
    validarButton.update(w => w.onClick = async () => {
        modal.close({ result: messageBoxResult.yes });
    });

    modal.standardButtons.addSimpleTopCloseButton(() => {
        return messageBoxResult.cancel;
    });
}

defineEmits([...modalDefinedEmits]);
</script>

<style scoped lang="scss">
.viewer-document-box {
    display: flex;
    justify-content: center;
}
</style>
